export function getStrapiURL(apiUrl, path = "") {
  return `${apiUrl || "http://localhost:1337"}${path}`;
}
